// extracted by mini-css-extract-plugin
export default {"labResultCareComponent":"LabResultCareComponent_labResultCareComponent__7z23i","analysis":"LabResultCareComponent_analysis__d6cZw","unit":"LabResultCareComponent_unit__v44zo"};